module.exports = __webpack_public_path__ + "static/JasmineMartinez-4cfd87947edd6c47ed93125dc7792537.jpg";